module.exports = __webpack_public_path__ + "img/DW365-011.da8725b3.jpg";